import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()



// WEBPACK FOOTER //
// ./src/js/helpers/history.js